<template>
  <div class="fullname">
    <div class="fullname_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">上传{{ $route.query.label }}</div>
      <div class="determine" @click="setSave">提交</div>
    </div>
    <van-row class="fullname_bottm" gutter="12">
      <template v-if="arr.length">
        <van-col
          span="12"
          v-for="(item, index) in arr"
          :key="item"
          style="margin-bottom: 20px"
        >
          <div class="img-box">
            <img :src="$global.imgUrl + item" alt="" />
            <img
              class="delete-btn"
              :src="require(`@/assets/img/mobile-img/upload-close.png`)"
              alt=""
              @click="() => arr.splice(index, 1)"
            />
          </div>
        </van-col>
      </template>
      <van-col span="12">
        <van-uploader
          v-if="$route.query.length > arr.length"
          :max-size="2 * 1024 * 1024"
          :before-read="beforeRead"
          :after-read="(file) => clzpAfterRead(file)"
          @oversize="onOversize"
        >
          <div class="upload_box">
            <div class="upload_default_box">
              <img
                class="upload_icon"
                :src="require(`@/assets/img/mobile-img/upload_icon.png`)"
                alt=""
              />
              <p class="upload_tip">上传{{ $route.query.label }}</p>
            </div>
          </div>
        </van-uploader>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "uploadPage",
  data() {
    return {
      userInfoObj: {},
      arr: [],
    };
  },
  created() {
    // 已认证完成
    let pageQuery = this.$route.query;
    if (sessionStorage.getItem(pageQuery.objName)) {
      this.userInfoObj = JSON.parse(sessionStorage.getItem(pageQuery.objName));
      this.arr = this.userInfoObj[pageQuery.key]
        ? this.userInfoObj[pageQuery.key].split(",")
        : [];
    }
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    setSave() {
      let pageQuery = this.$route.query;
      this.$set(this.userInfoObj, pageQuery.key, this.arr.join(","));
      sessionStorage.setItem(
        pageQuery.objName,
        JSON.stringify(this.userInfoObj)
      );
      window.history.go(-1);
    },

    //校验上传图片大小
    onOversize(file) {
      Toast("文件大小不能超过2MB");
    },
    //校验图片的格式
    beforeRead(file) {
      if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
        Toast("仅支持JPG、JPEG、PNG格式");
        return false;
      }
      return true;
    },

    //照片上传事件方法
    async clzpAfterRead(file) {
      // 创建一个空对象实例
      let formData = new FormData();
      // 调用append()方法添加数据
      formData.append("file", file.file);
      const res = await this.$apis.myServe.uploadFileMannual(formData);
      this.arr.push(res.data);
    },
  },
};
</script>

<style lang='scss' scoped>
.fullname {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;

  .fullname_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
      cursor: pointer;
    }
  }

  .fullname_bottm {
    padding: 15px;

    .upload_box,
    .upload_card_box {
      width: 166px;
      height: 105px;
      background-color: #f9f9f9;
      border-radius: 6px;
      overflow: hidden;

      .upload_img {
        width: 100%;
        height: 100%;
      }
      .upload_default_box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
      }

      .upload_default_img {
        padding: 6px;
        width: 100%;
        height: 100%;
      }

      .upload_icon {
        width: 18px;
        height: 17px;
      }

      .upload_tip {
        margin-top: 10px;
        font-size: 13px;
        color: #999999;
        line-height: 19px;
      }
    }

    .upload_card_box {
      background-color: #f7f9ff;
    }

    .img-box {
      width: 166px;
      height: 105px;
      border-radius: 6px;
      border: 1px solid #999999;
      position: relative;
      box-sizing: border-box;

      & > img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: fill;
      }

      .delete-btn {
        width: 15px;
        height: 15px;
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>